<div>
    <button pButton type="button" label="Back to Inbox" [routerLink] = "'../message-center'"
    ></button>
</div>


<div class="ui-g-12">
    <div class="card no-margin">
        <form #messageForm="ngForm" (ngSubmit)="sendMessage()" accept-charset="UTF-8">
            <p-fieldset>
                <p-header><b>Compose Email</b></p-header>
                <div class="ui-g">
                    <div class="ui-g-6">
                        <div class="p-field p-grid">
                            <label>Choose the Recipient</label>

                            <div><br></div>

                        </div>
                    </div>
                </div>
                <div class="ui-g">
                    <div class="ui-g-6">
                        <div class="p-field p-grid">
                            <div class="p-field-radiobutton">
                                <p-radioButton name="user" value="patient" [(ngModel)]="user_type"
                                    (click)="message.to_user_guid=[]" [disabled]="posting"></p-radioButton>
                                <label for="patient" style="padding-left:10px">Patient</label>
                            </div>
                            <br>

                            <p-dropdown class="notranslate" [(ngModel)]="message.patient_guid" [options]="patients" name="patient"
                                #patient="ngModel" [disabled]="user_type=='doctor' || user_type==null || posting"
                                required [filter]="true" filterBy="label">
                            </p-dropdown>
                            <div *ngIf="patient.invalid && (patient.dirty || patient.touched)"
                                class="alert alert-danger">
                                <div *ngIf="patient.errors.required">
                                    Choose a Patient.
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="ui-g-6">
                        <div class="p-field p-grid">
                            <div class="p-col">
                                <div class="p-field-radiobutton">
                                    <p-radioButton name="doctor" value="doctor" [(ngModel)]="user_type"
                                        (click)="message.patient_guid=null" [disabled]="posting"></p-radioButton>
                                    <label for="user" style="padding-left:10px">Health Care Provider(s)</label>
                                </div>
                                <br>
                                <p-multiSelect class="notranslate" [(ngModel)]="message.to_user_guid" [options]="doctor_list"
                                    [filter]="true" name="doctors" #doctors="ngModel" required
                                    defaultLabel="Select a Health Care Provider(s)"
                                    [disabled]="user_type=='patient' || user_type==null || posting">
                                </p-multiSelect>
                                <div *ngIf="doctors.invalid && (doctors.dirty || doctors.touched)"
                                    class="alert alert-danger">
                                    <div *ngIf="doctors.errors.required">
                                        Choose a health care provider(s).
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="ui-g-12" style="float: right;">
                    <div class="ui-g-6"></div>
                    <div class="ui-g-6">
                        <div class="p-field-checkbox">
                            <p-checkbox [(ngModel)]="is_filter" binary="true" inputId="binary"
                                (ngModelChange)="CallCountryAndSpecialtyFn()" name="filter"
                                [disabled]="user_type=='patient' || user_type==null || posting"></p-checkbox>
                            <label for="binary" style="padding-left:10px">Filter by Country or
                                Specialty/Occupation?</label>
                        </div>
                    </div>
                </div>
                <div *ngIf="this.is_filter">
                    <div class="ui-g-12" style="float: right;">
                        <div class="ui-g-6"></div>
                        <div class="ui-g-6">Country : </div>
                        <div class="ui-g-6"></div>
                        <div class="ui-g-6">
                            <p-dropdown [(ngModel)]="param.country_id" [options]="countries" [filter]="true" filterBy="label"
                                (ngModelChange)="GetDoctors()" name="countriesModel" #countriesModel="ngModel"
                                placeholder="Select a Country"
                                [disabled]="posting || !is_filter || user_type=='patient' || user_type==null">
                            </p-dropdown>
                        </div>
                    </div>
                    <div class="ui-md-12" style="float: right;">
                        <div class="ui-g-6"></div>
                        <div class="ui-g-6">Specialty/Occupation : </div>
                        <div class="ui-g-6"></div>
                        <div class="ui-g-6">
                            <p-dropdown [(ngModel)]="param.specialty_id" [options]="specialties" [filter]="true"
                                filterBy="label" (ngModelChange)="GetDoctors()" name="specialtiesModel"
                                #specialtiesModel="ngModel" placeholder="Select a Specialty/Occupation"
                                [disabled]="posting || !is_filter || user_type=='patient' || user_type==null">
                            </p-dropdown>
                        </div>
                    </div>
                </div>





                <div class="ui-g-12">
                    <div class="p-col">
                        <label for="Subject">Subject</label><br>
                        <input id="Subject" type="text" pInputText [pKeyFilter]="textarea" placeholder="Subject"
                            style="width:50%;" [(ngModel)]="message.subject" name="subjectmodel"
                            [maxlength]="max_subject_length" #subjectmodel="ngModel" required>
                        <div class="ui-g-12" style="float: left;">
                            <p [style.color]="message.subject.length-max_subject_length-1>0?'red':'green'"
                                style="float: right;">
                                {{(max_subject_length+1-message.subject.length)
                                <0?0:max_subject_length-message.subject.length}} of {{max_subject_length}} characters
                                    left </p>
                        </div>
                        <div *ngIf="subjectmodel.invalid && (subjectmodel.dirty || subjectmodel.touched)"
                            class="alert alert-danger">
                            <div *ngIf="subjectmodel.errors.required">
                                Subject is required.
                            </div>

                        </div>
                    </div>

                </div>

                <div class="ui-g-12">
                    <div class="p-field p-grid">
                        <textarea [rows]="5" [cols]="80" pInputTextarea [(ngModel)]="message.message"
                            class="format-lines" name="messagemodel" placeholder="Enter your message here"
                            #messagemodel="ngModel" [maxlength]="max_message_length" required></textarea>
                        <div class="ui-g-12" style="float: left;">
                            <p [style.color]="message.message.length-max_message_length-1>0?'red':'green'"
                                style="float: right;">
                                {{(max_message_length+1-message.message.length)
                                <0?0:max_message_length-message.message.length}} of {{max_message_length}} characters
                                    left </p>
                        </div>
                        <div *ngIf="messagemodel.invalid && (messagemodel.dirty || messagemodel.touched)"
                            class="alert alert-danger">
                            <div *ngIf="messagemodel.errors.required">
                                Message is required.
                            </div>

                        </div>
                    </div>

                </div>

                <div class="text-center compose-btn">
                    <button pButton type="submit" label="Send" icon="fa fa-send m-l-5" style="margin-left: 80%;"
                        [disabled]="!messageForm.valid || posting"></button>
                    <button pButton type="button" label="Discard" icon="fa fa-trash-o m-l-5"
                        style="margin-left: 3%;"></button>
                </div>
                <p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="posting" strokeWidth="6">
                </p-progressSpinner>
                <div *ngIf="response.success!=null && response.success==false" class="alert alert-danger">
                    <p *ngIf="response.error!=null">{{response.error.message}}</p>
                    <div *ngIf="serverError!=null">
                        <div *ngIf="serverError.error!=null && serverError.statusCode!=500">
                            <p *ngFor="let message of serverError.message">{{message}}</p>
                        </div>
                        <div *ngIf="serverError.error!=null && serverError.statusCode===500">
                            <p>{{serverError.message}}</p>
                        </div>
                    </div>


                </div>
                <div *ngIf="response.success!=null && response.success==true" style="color: green;">
                    <p>Your message has been sent</p>
                </div>
            </p-fieldset>
        </form>

    </div>
</div>